<template>
  <ul class="sidebar-menu">
    <router-link tag="li" class="pageLink" to="/admin/dashboard">
      <a>
        <i class="icon ion-ios-pie"></i>
        <span class="page">Dashboard</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/admin/report">
      <a>
        <i class="icon ion-ios-paper"></i>
        <span class="page">Reports</span>
      </a>
    </router-link>
    <li class="treeview">
      <a href="#">
        <i class="icon ion-folder"></i>
        <span class="treeview-title">Master Data</span>
        <span class="pull-right-container pull-right">
          <i class="icon ion-ios-arrow-forward"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <router-link tag="li" class="pageLink" to="/admin/master/membershiptype">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Membership Type</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/master/membershipcategory">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Membership Category</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/master/guesttype">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Guest Type</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/master/gender">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Gender</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/master/maritalstatus">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Marital Status</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/master/bloodtype">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Blood Type</span>
          </a>
        </router-link>                              
        <router-link tag="li" class="pageLink" to="/admin/master/religion">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Religion</span>
          </a>
        </router-link>
      </ul>
    </li>
    <router-link tag="li" class="pageLink" to="/admin/membership">
      <a>
        <i class="icon ion-card"></i>
        <span class="page">Membership</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/admin/group">
      <a>
        <i class="icon ion-android-contacts"></i>
        <span class="page">Group</span>
      </a>
    </router-link>
    <li class="treeview">
      <a href="#">
        <i class="icon ion-person"></i>
        <span class="treeview-title">Guest</span>
        <span class="pull-right-container pull-right">
          <i class="icon ion-ios-arrow-forward"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <router-link tag="li" class="pageLink" to="/admin/guest">
          <a>
            <i class="icon ion-user"></i>
            <span class="page">List of Guest</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/guest/guestmembership">
          <a>
            <i class="icon ion-user"></i>
            <span class="page">List of Membership of Guest</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/checkinoutlocation">
          <a>
            <i class="icon ion-map-marker"></i>
            <span class="page">Check-in/out location</span>
          </a>
        </router-link>         
      </ul>
    </li>
    <li class="treeview">
      <a href="#">
        <i class="icon ion-connection-bars"></i>
        <span class="treeview-title">Sales Process</span>
        <span class="pull-right-container pull-right">
          <i class="icon ion-ios-arrow-forward"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <router-link tag="li" class="pageLink" to="/admin/sales/producttype">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Product Type</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/sales/productcategory">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Product Category</span>
          </a>
        </router-link>        
        <router-link tag="li" class="pageLink" to="/admin/sales/product">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Product</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/sales/price">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Price</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/sales/salesorder">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Sales Order</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/sales/invoice">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Customer Invoice</span>
          </a>
        </router-link>             
        <router-link tag="li" class="pageLink" to="/admin/sales/bin">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">BIN (Bank Identification)</span>
          </a>
        </router-link> 
        <router-link tag="li" class="pageLink" to="/admin/sales/cardfee">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Card Fee</span>
          </a>
        </router-link> 
      </ul>
    </li>
    <li class="treeview">
      <a href="#">
        <i class="icon ion-ios-cart"></i>
        <span class="treeview-title">Point of Sales(PoS)</span>
        <span class="pull-right-container pull-right">
          <i class="icon ion-ios-arrow-forward"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <router-link tag="li" class="pageLink" to="/admin/pos/dashboard">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Dashboard</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/pos/session">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Session</span>
          </a>
        </router-link>        
        <router-link tag="li" class="pageLink" to="/admin/pos/order">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Order</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/pos/config">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">PoS Config</span>
          </a>
        </router-link>                    
      </ul>
    </li>
    <li class="treeview">
      <a href="#">
        <i class="icon ion-cash"></i>
        <span class="treeview-title">e-Payment</span>
        <span class="pull-right-container pull-right">
          <i class="icon ion-ios-arrow-forward"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <router-link tag="li" class="pageLink" to="/admin/payment/order">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">List of Orders</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/payment/payment">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">List of Payments</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/payment/clearing">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Payment Clearing</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/payment/clearingsession">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">List of Clearing Payments</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/payment/clearingdetail">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">List of Clearing Payments - Details</span>
          </a>
        </router-link>        
      </ul>
    </li>
    <li class="treeview">
      <a href="#">
        <i class="icon ion-android-checkmark-circle"></i>
        <span class="treeview-title">Gate Management</span>
        <span class="pull-right-container pull-right">
          <i class="icon ion-ios-arrow-forward"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <router-link tag="li" class="pageLink" to="/admin/gate/passcode">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Passcode</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/gate/gate">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">List of Gates</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/gate/paymentmethod">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Payment Methods</span>
          </a>
        </router-link>
        <!-- <router-link tag="li" class="pageLink" to="/manualcheckinout">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Manual Check-In/Out</span>
          </a>
        </router-link> -->
      </ul>
    </li>    
    <li class="treeview">
      <a href="#">
        <i class="icon ion-clipboard"></i>
        <span class="treeview-title">Reservation</span>
        <span class="pull-right-container pull-right">
          <i class="icon ion-ios-arrow-forward"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <router-link tag="li" class="pageLink" to="/admin/reservation/court">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Court</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/reservation/reservation">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">List of Reservation</span>
          </a>
        </router-link>
      </ul>
    </li>    
    <li class="treeview">
      <a href="#">
        <i class="icon ion-android-options"></i>
        <span class="treeview-title">Settings</span>
        <span class="pull-right-container pull-right">
          <i class="icon ion-ios-arrow-forward"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <router-link tag="li" class="pageLink" to="/admin/settings/company">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Company</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/settings/project">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Project</span>
          </a>
        </router-link>        
        <router-link tag="li" class="pageLink" to="/admin/settings/user">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">User</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/settings/bank">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Bank</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/settings/bankaccount">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Bank Account</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/settings/holiday">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Holiday Calendar</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/settings/workingcalendar">
          <a>
            <i class="icon ion-android-arrow-dropright"></i>
            <span class="page">Working Calendar</span>
          </a>
        </router-link>
        <li class="treeview">
          <a href="#">
            <i class="icon ion-cog"></i>
            <span class="treeview-title">Role</span>
            <span class="pull-right-container pull-right">
              <i class="icon ion-ios-arrow-forward"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            <router-link tag="li" class="pageLink" to="/admin/settings/authobject">
              <a>
                <i class="icon ion-android-arrow-dropright"></i>
                <span class="page">Authorization Objects</span>
              </a>
            </router-link>             
            <router-link tag="li" class="pageLink" to="/admin/settings/authfield">
              <a>
                <i class="icon ion-android-arrow-dropright"></i>
                <span class="page">Authorization Fields</span>
              </a>
            </router-link>
            <router-link tag="li" class="pageLink" to="/admin/settings/role">
              <a>
                <i class="icon ion-android-arrow-dropright"></i>
                <span class="page">Role</span>
              </a>
            </router-link>                                   
          </ul>
        </li>                                    
      </ul>
    </li>   
  </ul>
</template>

<script>
export default {
  name: 'SidebarMenu'
}
</script>

<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .ion-arrow-left-b,
.sidebar-menu li.active > a > .pull-right-container > .ion-arrow-left-b {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?50d57946